// src/components/common/ConfirmModal/ConfirmModal.jsx
import React from 'react';
import styles from './ConfirmModal.module.css';

const ConfirmModal = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    isLoading = false,
    danger = false,
    children,
}) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget && !isLoading) {
            onClose();
        }
    };

    return (
        <div className={styles.modalBackdrop} onClick={handleBackdropClick}>
            <div className={styles.confirmModal}>
                <div style={{ padding: '28px' }}>
                    <h3
                        style={{
                            margin: '0 0 8px 0',
                            color: danger ? 'var(--danger-color)' : 'var(--text-primary)',
                        }}
                    >
                        {title}
                    </h3>
                    <p style={{ margin: '16px 0', lineHeight: '1.5', color: 'var(--text-secondary)' }}>
                        {message}
                    </p>
                    {children}
                    <div
                        className={styles.formActions}
                        style={{
                            marginTop: '16px',
                            paddingTop: '20px',
                            borderTop: '1px solid var(--border-color)',
                        }}
                    >
                        <button
                            onClick={onClose}
                            className={styles.secondaryButton}
                            disabled={isLoading}
                        >
                            {cancelText}
                        </button>
                        <button
                            onClick={onConfirm}
                            className={styles.primaryButton}
                            style={
                                danger
                                    ? {
                                        background:
                                            'linear-gradient(135deg, var(--danger-color) 0%, var(--danger-dark) 100%)',
                                    }
                                    : {}
                            }
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <span className={styles.buttonSpinner}></span>
                                    Processando...
                                </>
                            ) : (
                                confirmText
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;